import { config } from '@react-spring/web'
export default config.gentle
